export type BooleanMap = Record<string, boolean>;

export const getVisibleSelectedTags = (
  stoneCut: BooleanMap,
  excludedTags: string[],
): { visibleSelectedTags: string[]; allTagsSelected: boolean } => {
  const selectedTags = Object.keys(stoneCut).filter((key) => stoneCut[key] === true);
  const selectableTags = Object.keys(stoneCut).filter((key) => !excludedTags.includes(key));
  const allTagsSelected = selectableTags.every((key) => stoneCut[key] === true);
  const visibleSelectedTags = selectedTags.filter((key) => !excludedTags.includes(key));

  return { visibleSelectedTags, allTagsSelected };
};

export const toggleStoneCutSelection = (
  current: BooleanMap,
  shape: string,
  excludedTags: string[],
): BooleanMap => {
  const keys = Object.keys(current);
  const selectableKeys = keys.filter((key) => !excludedTags.includes(key));
  const selected = selectableKeys.filter((key) => current[key]);
  const isAllSelected = selected.length === selectableKeys.length;

  if (isAllSelected) {
    return Object.fromEntries(
      keys.map((key) => {
        if (excludedTags.includes(key)) return [key, false];
        return [key, key === shape];
      }),
    );
  }

  const nextValue = !current[shape];
  if (!nextValue && selected.length === 1 && selected[0] === shape) {
    return Object.fromEntries(
      keys.map((key) => [key, excludedTags.includes(key) ? false : true]),
    );
  }

  const nextStoneCut: BooleanMap = {
    ...current,
    [shape]: nextValue,
  };

  excludedTags.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(nextStoneCut, key)) {
      nextStoneCut[key] = false;
    }
  });

  return nextStoneCut;
};
